const redirectStorageKey = 'wcgRedirect';
const redirectStorageExp = 1800000;
if(new URL(window.location.href).searchParams.get('force') == 'true') setWithExpiry(redirectStorageKey, 'close', redirectStorageExp);
const redirectValue = getWithExpiry(redirectStorageKey);

if(redirectValue && redirectValue !== 'close') {
  window.location.href = redirectValue;
}

function setWithExpiry(key, value, ttl) { //ttl is time in ms
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	}
	localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem(key)
		return null
	}
	return item.value
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.debouncedDispatchChangeEvent = debounce(() => {
      this.closest('.variant-item')?.querySelector('.loading-spinner__quantity-popover')?.classList.remove('hidden');
      this.input.dispatchEvent(this.changeEvent);
    }, ON_CHANGE_DEBOUNCE_TIMER);

  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    
    const previousValue = this.input.value;

    if(event.target.closest('.variant-item-all')) {
      event.target.closest('quick-order-list').querySelectorAll(`.variant-item:not(.variant-item-all) .quantity__button[name="${event.target.name}"]`).forEach(el => el.click());
      return;
    }

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.debouncedDispatchChangeEvent();

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.boundButtons = new Set();

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      if(!this.boundButtons.has(summary)) {
        summary.addEventListener('click', this.onSummaryClick.bind(this));
        this.boundButtons.add(summary);
      }
    });
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not([data-target])'
    ).forEach((button) => {
      if(!this.boundButtons.has(button)) {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
        this.boundButtons.add(button);
      }
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
      setTimeout(() => {
        this.mainDetailsToggle.closest('header-drawer') && this.mainDetailsToggle.closest('header-drawer').classList.add('header-drawer-submenu-open');
      }, 200);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    if(event.currentTarget && event.currentTarget.matches('.menu-drawer-header__close-button-main')) {
      event.preventDefault();
      this.mainDetailsToggle.firstElementChild.dispatchEvent(new Event('click'));
    } else {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    this.mainDetailsToggle.closest('header-drawer.header-drawer-submenu-open') && this.mainDetailsToggle.closest('header-drawer.header-drawer-submenu-open').classList.remove('header-drawer-submenu-open');
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.querySelectorAll('.menu-drawer__navigation > ul > li > details > summary, .menu-drawer__navigation > ul > li > a').forEach((navToggle) => {
      navToggle.addEventListener('mouseover', this.onMouseOver.bind(this));
      navToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    });
  }
  
  onMouseOver(event) {
    document.body.classList.add('menu-drawer-hovering');
  }

  onMouseLeave(event) {
    document.body.classList.remove('menu-drawer-hovering');
  }

  setMenuHeaderHeight() {
    setTimeout(() => {
      document.documentElement.style.setProperty('--menu-drawer-header-height', `${this.querySelector('.menu-drawer__header').offsetHeight}px`);
    });
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    this.setMenuHeaderHeight();
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden', 'header-drawer-open');
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove('header-drawer-open');
    window.removeEventListener('resize', this.onResize);
    this.querySelectorAll('.menu-drawer__navigation > ul > li > details > summary, .menu-drawer__navigation > ul > li > a').forEach((navToggle) => {
      navToggle.removeEventListener('mouseover', this.onMouseOver);
      navToggle.removeEventListener('mouseleave', this.onMouseLeave);
    });
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    this.setMenuHeaderHeight();
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved || this.classList.contains('quick-add-modal__card')) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) stickyHeader.preventReveal = true;
    if(this.classList.contains('quick-add-modal__card')) {
      document.body.classList.add('quick-add-open');
      document.querySelector(`[data-modal="#${this.getAttribute('id')}"]`).closest('.grid__item').classList.add('quick-add-open');
    } else if(this.classList.contains('quick-add-modal__pdp')) {
      if(this.classList.contains('quick-add-modal__drawer')) {
        document.body.classList.add('drawer-quick-add-open');
      } else {
        document.body.classList.add('pdp-quick-add-open');
      }
    } else if(this.classList.contains('cart-drawer__clear-modal')) {
      document.body.classList.add('clear-modal-open');
    } else if(this.classList.contains('redirect-modal')) {
      document.body.classList.add('redirect-modal-open');
      if(opener) {
console.log('was toggled manually!')
      }
    } else {
      document.body.classList.add('overflow-hidden');
    }
    this.setAttribute('open', '');
    document.querySelectorAll(`[data-modal="#${this.getAttribute('id')}"]`).forEach((el) => el.setAttribute('open', ''));
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    if(this.classList.contains('quick-add-modal__card')) {
      document.body.classList.remove('quick-add-open');
      document.querySelector(`[data-modal="#${this.getAttribute('id')}"]`).closest('.grid__item').classList.remove('quick-add-open');
    } else if(this.classList.contains('quick-add-modal__pdp')) {
      if(this.classList.contains('quick-add-modal__drawer')) {
        document.body.classList.remove('drawer-quick-add-open');
      } else {
        document.body.classList.remove('pdp-quick-add-open');
      }
    } else if(this.classList.contains('cart-drawer__clear-modal')) {
      document.body.classList.remove('clear-modal-open');
    } else if(this.classList.contains('redirect-modal')) {
      document.body.classList.remove('redirect-modal-open');
      document.querySelectorAll('.button-redirect[data-url]').forEach(el => {
        const currentUrl = new URL(el.dataset.url);
        currentUrl.searchParams.delete('force');
        el.dataset.url = currentUrl.toString();
      });
    } else {
      document.body.classList.remove('overflow-hidden');
    }
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    document.querySelectorAll(`[data-modal="#${this.getAttribute('id')}"]`).forEach((el) => el.removeAttribute('open'));
    if(!this.classList.contains('quick-add-modal')) removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
    };
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
            this.closest('.quick-add-modal').classList.add('loaded');
          })
          .catch((e) => {
            console.error(e);
          });
      }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: `0px 0px ${Math.round(window.innerHeight * 2.5)}px 0px` }).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`) || document.querySelector(`.search-modal #QuickBulkModal-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = (this.dataset.loop === 'true');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide') || this.slider.querySelector('.slider__slide');
    
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide') || this.slider.querySelector('.slider__slide');
    
    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);

    if(!this.enableSliderLooping) return;

    this.wasClicked = true;

    const isFirstSlide = this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0;
    const isLastSlide = this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]);

    if (!isFirstSlide && !isLastSlide) {
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.linkToSlideHandler = this.linkToSlide.bind(this);
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlideHandler));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update(updateDots = false) {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    
    if(this.sliderControlButtons[this.currentPage - 1]) {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    if(updateDots === true) {
      this.sliderControlLinksArray = Array.from(this.querySelectorAll('.slider-buttons .slider-counter__link'));
      if(this.sliderControlLinksArray.length) this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlideHandler));
    }

    this.updateColorScheme([this.sliderControlWrapper]);

  }

  updateColorScheme(elements) {
    if (!elements || this.parentNode.classList.contains('wcg_callout-testimonials') || this.parentNode.matches('media-gallery')) return;
    elements.forEach(element => {
      if(element) {
        const currentColorScheme = Array.from(element.classList).find(el => el.indexOf('color-scheme-') === 0);
        const newColorScheme = Array.from(this.sliderItems[this.currentPage - 1].querySelector('[class*="color-scheme-"]').classList).find(el => el.indexOf('color-scheme-') === 0);
        if(currentColorScheme && newColorScheme) {
          element.classList.remove(currentColorScheme);
          element.classList.add(newColorScheme);
        }
      }
    });
  }
  
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;
  cartUpdateUnsubscriber = undefined;
  
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
  }

  onCartUpdate(event) {
    if(event.source === 'cart-items' && this.classList.contains('related-products--cart')) {
      if(event.cartData.items.length > 0) {
        const firstProductId = event.cartData.items.slice(0, 1).at(0).product_id;
        if(parseInt(this.dataset.productId) !== firstProductId) {
          this.classList.add('reloading');
          this.querySelector(':scope > .loading__spinner')?.classList.remove('hidden');
          this.classList.remove('product-recommendations--loaded');
          this.dataset.productId = firstProductId;
          this.loadRecommendations(firstProductId);
        }
      } else {
        this.remove();
        window.scrollTo({ top: 0, behavior: "instant" });
      }
    }
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber?.();
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: `0px 0px ${Math.round(window.innerHeight * 2.5)}px 0px` }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) this.remove();

    const storageKey = `recommendations-${productId}-${this.dataset.url}`;
    const cachedResultsHtml = getWithExpiry(storageKey);
    if(cachedResultsHtml === null) {
      fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations?.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;

          if (html.querySelector('.grid__item')) {
            setWithExpiry(storageKey, recommendations.innerHTML, 259200000);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.onLoadRecommendationsFinish();
        });
    } else {
      this.innerHTML = cachedResultsHtml;
      this.onLoadRecommendationsFinish();
    }
  }
  
  onLoadRecommendationsFinish() {
    this.classList.add('product-recommendations--loaded');
    this.querySelector(':scope > .loading__spinner')?.classList.add('hidden');
    this.closest('.shopify-section, .cart-drawer')?.querySelectorAll('related-products').forEach((related) => {
      related.dispatchEvent(new CustomEvent('recommendationsLoaded', {
        detail: {
          element: this
        }
      }));
    });
    this.classList.remove('reloading');
    document.dispatchEvent(new CustomEvent('lazyloadProductGrid'));
    document.dispatchEvent(new CustomEvent('swym:initializeActionButtons'));
  }
  
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

document.addEventListener('click', (event) => {
  if(event && event.target) {
    if(event.target.closest('.submenu__close')) {
      event.target.closest('details').querySelector('.menu-drawer__back-button').click();
    }
    if(event.target.closest('.back-to-top')) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    if(event.target.closest('.drawer__button-quick-add')) {
      event.preventDefault();
      const modalId = event.target.dataset.modal;
      if(event.target.hasAttribute('open')) {
        document.querySelector(`${modalId}`).hide();
      } else {
        event.target.closest('.drawer').querySelector(`modal-opener[data-modal="${modalId}"] button`).click();
      }
    }
    if(event.target.closest('.card__button-quick-add')) {
      if(event.target.hasAttribute('open')) {
        document.querySelector(`${event.target.dataset.modal}`).hide();
      } else {
        event.target.closest('.card').querySelector('.quick-add__submit').click();
      }
    }
    if(event.target.closest('.card__button-toggle summary')) {
      const summaryEl = event.target.closest('.card__button-toggle summary');
      const cardEl = summaryEl.closest('.product-card-wrapper');
      if(cardEl) cardEl.classList.toggle('card-button-toggle-open', !summaryEl.parentNode.hasAttribute('open'));
    }
    if(event.target.closest('.drawer__continue-btn[data-close]')) {
      event.target.closest('cart-drawer').close();
    }
    if(event.target.closest('.wcg-register__submit-block')) {
      event.preventDefault();
      alert(window.registerStrings.pleaseRead);
    }
    if(event.target.closest('.button-redirect')) {
      if(event.target.closest('#Redirect')) {
        event.preventDefault();
        
        const buttonEl = event.target.closest('.button-redirect');
        const redirectUrl = new URL(buttonEl.dataset.url);
        const currentUrl = new URL(window.location.href);
        
        if(redirectUrl.origin !== currentUrl.origin) {
          setWithExpiry(redirectStorageKey, buttonEl.dataset.url, redirectStorageExp);
          window.location.href = buttonEl.dataset.url;
        } else {
          setWithExpiry(redirectStorageKey, 'close', redirectStorageExp);
          buttonEl.closest('modal-dialog').hide();
        }
      } else {
        localStorage.removeItem(redirectStorageKey);
        document.querySelectorAll('.button-redirect[data-url]').forEach(el => {
          const currentUrl = new URL(el.dataset.url);
          currentUrl.searchParams.set('force', 'true');
          el.dataset.url = currentUrl.toString();
        });
      }
    }
  }
});

document.addEventListener('keyup', (event) => {
  if(event && event.target) {
    if(event.target.closest('details.card__button-toggle')) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      event.target.closest('.product-card-wrapper').classList.toggle('card-button-toggle-open', event.target.hasAttribute('open'));
    }
  }
});

document.addEventListener('mouseover', (event) => {
  if(event && event.target && event.target.closest('.card__swatch')) {
    const badgeEl = event.target.closest('.product-card-wrapper').querySelector('.product__info-badges') || false;
    const swatchEl = event.target.closest('.card__swatch');
    const swatchUrl = swatchEl.dataset.url;
    const variantId = swatchEl.dataset.variantId;
    const swatchMediaId = swatchEl.dataset.mediaId;
    const hoveredSku = swatchEl.dataset.sku || '';

    const skuEl = swatchEl.closest('.product-card-wrapper').querySelector('.card__sku');
    const allCardLinkEls = swatchEl.closest('.product-card-wrapper').querySelectorAll('[id^="CardLink-"]');
    const allSaveEls = swatchEl.closest('.product-card-wrapper').querySelectorAll('.card__button-save');

    const badgeHtml = new DOMParser().parseFromString(swatchEl.dataset.badgeHtml, 'text/html') || false;
    if(badgeEl) {
      const newBadgeEl = badgeHtml.querySelector('.product__info-badge') || false;
      badgeEl.replaceChildren();
      if(newBadgeEl) badgeEl.replaceChildren(newBadgeEl);
    }

    const swatchImageHtml = new DOMParser().parseFromString(swatchEl.dataset.imageHtml, 'text/html') || false;
    const swatchImageEl = swatchImageHtml.querySelector('.media') || false;

    if(swatchImageHtml && swatchImageEl && !swatchEl.closest('.product-card-wrapper').querySelectorAll(`img[data-media-id="${swatchMediaId}"]`).length) {
      swatchEl.closest('.product-card-wrapper').querySelector('.card__media').appendChild(swatchImageEl);
      document.dispatchEvent(new CustomEvent('lazyloadProductGrid'));
    }

    const allImageEls = swatchEl.closest('.product-card-wrapper').querySelectorAll('.card__media .media');
    allImageEls.forEach((imageEl) => imageEl.setAttribute('data-active', imageEl.querySelector('img').dataset.mediaId === swatchMediaId));
    if(!swatchEl.closest('.product-card-wrapper').querySelector('.card__media .media[data-active="true"]')) swatchEl.closest('.product-card-wrapper').querySelector('.card__media .media').setAttribute('data-active', true);

    if(skuEl) skuEl.textContent = hoveredSku;
    if(allCardLinkEls.length) allCardLinkEls.forEach((el) => el.setAttribute('href', swatchUrl));
    if(window.wishlistConfig.type === 'variant' && allSaveEls.length) {
      allSaveEls.forEach((el, index) => {
        el.classList.remove('disabled', 'swym-added', 'swym-adding');
        el.setAttribute('data-variant-id', variantId);
        el.setAttribute('data-product-url', `${window.shopUrlDomain}${swatchUrl}`);
        if(index === (allSaveEls.length - 1)) document.dispatchEvent(new CustomEvent('swym:initializeActionButtons'));
      });
    }
  }
});

document.addEventListener('lazyloadProductGrid', (e) => {
  document.querySelectorAll('img.blur').forEach(el => {
    if(el.complete) {
      el.classList.add('loaded');
    } else {
      el.addEventListener('load', () => el.classList.add('loaded'));
    }
  });
});
document.dispatchEvent(new CustomEvent('lazyloadProductGrid'));

document.querySelectorAll('details[data-css-animate="true"] summary')
  .forEach(element => element.addEventListener('click', (event) => {
    const detailsElement = event.target.closest('summary').parentElement;
    const contentElement = event.target.closest('summary').nextElementSibling;
    // Chrome sometimes has a hiccup and gets stuck.
    if (contentElement.classList.contains('animation')) {
      // So we make sure to remove those classes manually,
      contentElement.classList.remove('animation', 'collapsing');
      // ... enforce a reflow so that collapsing may be animated again,
      void element.offsetWidth;
      // ... and fallback to the default behaviour this time.
      return;
    }

    const onAnimationEnd = cb => contentElement.addEventListener(
      "animationend", cb, {once: true}
    );

    // request an animation frame to force Safari 16 to actually perform the animation
    requestAnimationFrame(() => contentElement.classList.add('animation'));
    onAnimationEnd(() => contentElement.classList.remove('animation'));

    const isDetailsOpen = detailsElement.getAttribute('open') !== null;
    if (isDetailsOpen) {
      // prevent default collapsing and delay it until the animation has completed
      event.preventDefault();
      contentElement.classList.add('collapsing');
      onAnimationEnd(() => {
        detailsElement.removeAttribute('open');
        contentElement.classList.remove('collapsing');
      });
    }
  }));
  
const setWindowHeightCssVar = () => document.documentElement.style.setProperty('--window-inner-height', `${window.innerHeight}px`);

setWindowHeightCssVar();

window.addEventListener('resize', debounce((event) => {
  setWindowHeightCssVar();
}, ON_CHANGE_DEBOUNCE_TIMER));

const headerColorSchemeClass = Array.from(document.querySelector('.header-wrapper').classList).find(el => el.startsWith('color-scheme-'));
if(headerColorSchemeClass) document.querySelector('.shopify-policy__container')?.classList.add(headerColorSchemeClass);

const onCartChange = subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
  if(event.source === 'persistent-cart:load') return;
  if(event.cartCleared === true && window.persistentCart.cartData.count === 0) return;

  const cartObj = {};
  if(event.cartData.items) {
    cartObj.items = {};
    event.cartData.items.reverse().forEach(item => {
      cartObj.items[parseInt(item.variant_id)] = item.quantity;
    });
    cartObj.note = event.cartData.note;
    cartObj.attributes = event.cartData.attributes;
    cartObj.count = event.cartData.item_count;
    window.persistentCart.cartData = cartObj;
    const webhookData = JSON.parse(JSON.stringify(window.persistentCart));
    delete webhookData.liquidCartItems;
    delete webhookData.webhookUrl;

    try {
      await fetch(`${window.persistentCart.webhookUrl}`, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, method: `POST`, body: JSON.stringify(webhookData)});
    } catch(err) {
      console.error(`Problem sending cart data to metafields: ${err}`);
    }
  }
});

document.addEventListener('loadMetafieldCart', async (event) => {
  document.body.classList.add('loading-cart');

  const cartObj = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const sectionsToRender = cartObj ? cartObj.getSectionsToRender().map((section) => section.id) : [];

  const formData = new FormData();
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  try {
    if(window.persistentCart.cartData.count > 0) {
      Object.entries(window.persistentCart.cartData.items).forEach(([id, qty]) => {
        formData.append(`updates[${id}]`, Number(qty));
      });
      
      const metafieldIds = new Set(Object.keys(window.persistentCart.cartData.items));
      Object.keys(window.persistentCart.liquidCartItemsMap).forEach((existingId) => {
        if(!metafieldIds.has(existingId)) formData.append(`updates[${existingId}]`, 0);
      });
      
      formData.append('note', window.persistentCart.cartData.note);

      if(cartObj) {
        formData.append('sections', sectionsToRender);
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      const res = await fetch(routes.cart_update_url, config);
      let response = await res.json();

      if(response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'persistent-cart:load',
          errors: response.errors || response.description,
          message: response.message,
        });
        console.error(`Error loading persistent cart: ${response.errors || response.description}, message: ${response.message}`);
        return;
      }

      if(!cartObj) {
        window.location = window.routes.cart_url;
        return;
      }

      if(!response.sections) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('sections', sectionsToRender.join(','));

        try {
          const sectionsRes = await fetch(currentUrl);
          const sectionsResponse = await sectionsRes.json();
          if(sectionsResponse) {
            response.sections = sectionsResponse;
          }
        } catch(err) {
          console.error('Error fetching fallback sections:', err);
        }
      }

      if(!response || !response.sections) {
        console.error('No sections returned even after fallback fetch');
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'persistent-cart:load',
        cartData: response,
      });
      cartObj.renderContents(response);
      cartObj.classList.toggle('is-empty', response.item_count === 0);

    } else {
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if(cartItems && typeof cartItems.clearAll === 'function') {
        await cartItems.clearAll();
      }
    }
  } catch(error) {
    console.error('Persistent cart error:', error);
  } finally {
    document.body.classList.remove('loading-cart');
  }
});

document.addEventListener('DOMContentLoaded', async () => {
  if(Shopify.designMode) return;

  const redirectModal = document.getElementById('Redirect');
  if(redirectModal && redirectValue === null && new URL(window.location.href).searchParams.get('force') != 'true') {
    try {
      const resp = await fetch('/browsing_context_suggestions.json');
      const respJson = await resp.json();
      
      const storeCountry = window.shopCountries.includes('CA') ? 'CA' : 'US';
      const visitorCountry = respJson?.detected_values?.country?.handle || 'N/A';

      if(visitorCountry === 'CA' || visitorCountry === 'US') {
        if(storeCountry !== visitorCountry) {
          redirectModal.show();
        }
      } else if(storeCountry !== 'CA') {
        redirectModal.show();
      }
    } catch(err) {
      console.error(`Error fetching GeoIP data: ${err}`);
    }
  }

  if(typeof window.persistentCart === 'undefined') return;
  
  const liquidCartMatchesMetafield = Object.entries(window.persistentCart.cartData.items).every(([id, qty]) => window.persistentCart.liquidCartItemsMap[id] === Number(qty)) && window.persistentCart.cartData.count === window.persistentCart.liquidCartCount;

  if(!liquidCartMatchesMetafield) {
    document.dispatchEvent(new CustomEvent('loadMetafieldCart'));
  } else {
    document.body.classList.remove('loading-cart');
  }

});
